import { lazy } from "react";

const CreateEdit = lazy(() =>
  import("../../pages/UserAccess/UserRole/create-edit"),
);

const routes = [
  {
    path: "/user_role",
    element: lazy(() => import("../../pages/UserAccess/UserRole/index")),
  },
  {
    path: "/user_role/add",
    element: CreateEdit,
  },
  {
    path: "/user_role/edit/:id",
    element: CreateEdit,
  },
];

export default routes;
